import dayjs from 'dayjs';
import Text from '../../../atoms/Text';

interface ITableDateFieldProps {
    timestamp: number // provide in miliseconds
}

const TableDateField = ({timestamp}: ITableDateFieldProps) => {
  const [
    year, month, day, hour, minute, second
  ] = dayjs(timestamp).format('YYYY:MM:DD:HH:mm:ss').split(':');
  if (second) { // not aware of 0 because it is string

    return <div className='initialLiquidity text--grey-600'>
      <Text size={12}>{`${year}.${month}.${day}`}</Text>
      <Text size={12}>{`${hour}:${minute}:${second}`}</Text>
    </div>;
  }
  return null;
};

export default TableDateField;

